import React, { ChangeEvent, Component, useContext, useState } from "react";
import "./ZohoSyncAccountsModal.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import SupplierContext from "../../../../contexts/SupplierContext";

type Props = {
    closeModalFn: () => void;
    startSync: (includeContacts: boolean) => void;
};

export const ZohoSyncAccountsModal: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);

    const closeModal = () => {
        props.closeModalFn();
    };

    const [includeContacts, setIncludeContacts] = useState(false);

    const handleChange = (e: ChangeEvent<any>) => {
        setIncludeContacts(e.target.value);
    };

    const startSync = () => {
        props.startSync(includeContacts);
    };

    return (
        <div className={"ZohoSyncAccountsModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"sync_accounts"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            {supplierModel.has_contacts ? (
                <div>
                    <div>
                        <OwCheckbox
                            fn={handleChange}
                            name={"include_contacts"}
                            checked={includeContacts}
                            truthyVal={true}
                            falsyVal={false}
                            label={"include_contacts"}
                        />
                    </div>
                </div>
            ) : null}

            <div className={"mt-3"}>
                <OwButton title={"start"} fn={startSync} />
            </div>
        </div>
    );
};
